import { View } from './view';

export const СashIncome = () => {
    return View();
};
